import { GRID_WIDTH, GRID_HEIGHT, COLORS } from '../constants/gameConstants';

export const generateGrid = (gridWidth = GRID_WIDTH, gridHeight = GRID_HEIGHT) => {
  const grid = Array.from({length: gridHeight}, () =>
    Array.from({length: gridWidth}, () => COLORS[Math.floor(Math.random() * COLORS.length)])
  );

  // Ensure starting colors are not the same for Player (top-left) and AI (bottom-right)
  if (grid[0][0] === grid[gridHeight - 1][gridWidth - 1]) {
    const alternativeColors = COLORS.filter(color => color !== grid[0][0]);
    const newColor =
      alternativeColors[Math.floor(Math.random() * alternativeColors.length)];
    // Reshuffle AI's starting pixel to a different color
    grid[gridHeight - 1][gridWidth - 1] = newColor;
  }

  return grid;
};

export const getCellBorders = (grid, ownership, rowIndex, colIndex, gridWidth = GRID_WIDTH, gridHeight = GRID_HEIGHT) => {
  if (!ownership[rowIndex][colIndex]) {
    return {};
  }
  
  const player = ownership[rowIndex][colIndex];
  const borders = {
    borderTop: "1px solid black",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    borderLeft: "1px solid black"
  };
  
  // Check top neighbor
  if (rowIndex > 0 && ownership[rowIndex - 1][colIndex] === player) {
    borders.borderTop = "none";
  } else {
    borders.borderTop = player === "Player" ? "3px solid white" : "3px solid black";
  }
  
  // Check right neighbor
  if (colIndex < gridWidth - 1 && ownership[rowIndex][colIndex + 1] === player) {
    borders.borderRight = "none";
  } else {
    borders.borderRight = player === "Player" ? "3px solid white" : "3px solid black";
  }
  
  // Check bottom neighbor
  if (rowIndex < gridHeight - 1 && ownership[rowIndex + 1][colIndex] === player) {
    borders.borderBottom = "none";
  } else {
    borders.borderBottom = player === "Player" ? "3px solid white" : "3px solid black";
  }
  
  // Check left neighbor
  if (colIndex > 0 && ownership[rowIndex][colIndex - 1] === player) {
    borders.borderLeft = "none";
  } else {
    borders.borderLeft = player === "Player" ? "3px solid white" : "3px solid black";
  }
  
  return borders;
};